import { MoonPayBuyWidget, MoonPayProvider } from '@moonpay/moonpay-react';

type MoonPayWidgetProps = {
  src: string;
  baseCurrencyCode: string;
  baseCurrencyAmount: string;
  showOnlyCurrencies?: string;
  walletAddress?: string;
  externalTransactionId?: string;
  onTransactionCreated: () => Promise<void>;
};

const MoonPayWidget = ({
  src,
  baseCurrencyCode,
  baseCurrencyAmount,
  showOnlyCurrencies,
  walletAddress,
  externalTransactionId,
  onTransactionCreated,
}: MoonPayWidgetProps) => {
  const apiKey = new URL(src).searchParams.get('apiKey');
  if (!apiKey) {
    return null;
  }

  return (
    <MoonPayProvider apiKey={apiKey}>
      <MoonPayBuyWidget
        className="size-full rounded-2xl shadow-md"
        variant="embedded"
        baseCurrencyCode={baseCurrencyCode}
        baseCurrencyAmount={baseCurrencyAmount}
        showOnlyCurrencies={showOnlyCurrencies}
        walletAddress={walletAddress}
        externalTransactionId={externalTransactionId}
        onTransactionCreated={onTransactionCreated}
      />
    </MoonPayProvider>
  );
};

export default MoonPayWidget;
